const axios = require("axios");
const { sheetUrl  } = require("./constants");

let jiraToken = "";

async function fetchJiraToken() {
  try {
    const response = await axios.get(sheetUrl  + "/tabs/JiraToken");    
    jiraToken = response.data.jiraToken  
    return {jiraToken};
  } catch (error) {
    console.log(error.message);
    throw error.message;
  }
}

module.exports = {
  fetchJiraToken,
};